'use client';
import React, { useEffect, useState } from 'react';
import { useTranslations } from 'next-intl';
import ProjectService from '@/app/services/projects';
import ProjectGallery from './ProjectGallery';

const ProjectDetail = ({ params }: { params: any }) => {
    const t = useTranslations('Projects')
    const [project, setProject] = useState<any>(null)
    const [error, setError] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(false)

    async function getProjectDetails() {
        setIsLoading(true)
        try {
            const result: any = await ProjectService.getDetails(params?.id);
            if (result?.data?.success) {
                setProject(result?.data?.data)
                setError(false)
            } else {
                setError(true)
            }
        } catch (error: any) {
            setError(true)
        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => { getProjectDetails() }, [])
    return (
        <div className="bg-white min-h-screen">
            <div className="relative h-[60vh] w-full overflow-hidden">
                <img
                    src={project?.cover_image[0]?.url}
                    alt={project?.translations[params?.locale]?.name}
                    className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-black/30 flex items-end">
                    <div className="container mx-auto px-6 pb-12">
                        <span className="text-violet-400 font-medium uppercase tracking-widest text-sm">
                            {project?.category[`name_${params?.locale}`]}
                        </span>
                        <h1 className="text-4xl md:text-6xl text-white font-bold mt-2">
                            {project?.translations[params?.locale]?.name}
                        </h1>
                    </div>
                </div>
            </div>

            <div className="container mx-auto px-6 py-16">
                <div className="flex flex-col lg:flex-row gap-12">
                    <div className="lg:w-1/3 order-2 lg:order-1">
                        <div className="space-y-8 sticky top-24">
                            <div>
                                <h4 className="text-gray-400 uppercase text-xs font-bold tracking-wider">{t("client")}</h4>
                                <p className="text-xl font-medium text-gray-900">{project?.client?.name}</p>
                            </div>
                            <div>
                                <h4 className="text-gray-400 uppercase text-xs font-bold tracking-wider">{t("category")}</h4>
                                <p className="text-xl font-medium text-gray-900">{project?.category[`name_${params?.locale}`]}</p>
                                <img
                                    src={project?.category?.icon?.url?.replace('http:','https:')}
                                    alt={project?.category[`name_${params?.locale}`]}
                                    className="w-30 h-30 mt-4"
                                />
                            </div>
                        </div>
                    </div>
                    <div className="lg:w-2/3 order-1 lg:order-2">
                        <h2 className="text-2xl font-bold mb-6">{t("about_project")}</h2>
                        <p className="text-gray-600 text-lg leading-relaxed mb-8">
                            {project?.translations[params?.locale]?.description}
                        </p>
                    </div>
                </div>
                <div className="mt-10">
                    <p className="text-gray-600 text-lg leading-relaxed mb-8">
                        {project?.translations[params?.locale]?.content ? (
                            <div style={{ textAlign: "justify", overflowWrap: 'break-word' }}
                                dangerouslySetInnerHTML={{
                                    __html: `
                                            <style>
                                            a {
                                               color: #a684ff
                                            }
                                            </style>
                                            ${project?.translations[params?.locale]?.content}
                                            `,
                                }} />
                        ) : (
                            <></>
                        )}
                    </p>
                </div>
                {project?.gallery?.length > 0 && (
                    <div className="mt-24">
                        <h3 className="text-3xl font-bold mb-10">{t("project_gallery")}</h3>
                        <div className='pb-4 pt-4'>
                            <ProjectGallery project_images={project?.gallery} orientation={project?.orientation} />
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProjectDetail;